import { defineMessages } from 'react-intl';

export const messages: {
	privateTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	restrictedTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	restrictedTooltip: {
		id: 'search-page.results.restricted-result-tooltip',
		defaultMessage: 'Only visible to specific people',
		description:
			'The text displayed in the tooltip when the user hovers over the restricted label.',
	},
	privateTooltip: {
		id: 'search-page.results.private-result-tooltip',
		defaultMessage: 'Only visible to you',
		description: 'The text displayed in the tooltip when the user hovers over the private label.',
	},
});
